import React, { FunctionComponent } from 'react';
import AuthChooseRolePageContainer from '../../containers/AuthChooseRolePageContainer';

const AuthChooseRolePage: FunctionComponent = () => {
  return <AuthChooseRolePageContainer />;
};

export default AuthChooseRolePage;
